export const hero = {
  title: "L'école dans la nature où les enfants grandissent heureux et en confiance",
  subtitle: "Une école de 80 enfants au maximum à Gondomar : inspiration Montessori, un enseignant pour 10-12 enfants, trois langues au quotidien avec l'anglais comme langue principale, et l'accréditation NEASC.",
  bookVisit: "Réserver une visite",
  discoverGandara: "Découvrir Gándara"
};
